import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import BootstrapperContextProvider from "./context/bootstrapperContext";
import LanguageProvider from "./context/languageContext";
import UserContextProvider from "./context/userContext";
import GlobalErrorBoundary from "./gloablErrorBoundary";
import routes from "./route";
import ErrorProvider from "./route/error/provider";
import { LoadingContextProvider } from "./context/loaderContext";
import CommercialThemeProvider from "./theme/theme";
import ProductContextProvider from "./context/product-context/productContext";
import ProductContextHelper from "./context/product-context/helper";
import useCsrfProtection from "./pages/shared/hooks/useCsrfProtection";
import useProductRefUrlExtractor from "./pages/shared/hooks/useProductRefUrlExtractor";
import GTM from "./util/tracking/gtm";

export default function App(): React.JSX.Element {
  useCsrfProtection();
  const productRef = useProductRefUrlExtractor({
    providedProductRef: ProductContextHelper.getProductRefFromUrl(),
  });

  useEffect(() => {
    GTM.enableGTM();
  }, []);

  return (
    <GlobalErrorBoundary>
      <ErrorProvider>
        <LoadingContextProvider>
          <LanguageProvider>
            <BootstrapperContextProvider productRef={productRef}>
              <ProductContextProvider productRef={productRef}>
                <UserContextProvider>
                  <CommercialThemeProvider>
                    <Router>
                      <Routes>
                        {routes.map((route) => (
                          <Route
                            key={route.path}
                            path={route.path}
                            element={<route.component routes={route.routes} />}
                          />
                        ))}
                      </Routes>
                    </Router>
                  </CommercialThemeProvider>
                </UserContextProvider>
              </ProductContextProvider>
            </BootstrapperContextProvider>
          </LanguageProvider>
        </LoadingContextProvider>
      </ErrorProvider>
    </GlobalErrorBoundary>
  );
}

App.displayName = "App";
